import { buildTimestamp } from '../../buildTimestamp.json';

export const environment = {
  buildTimestamp: buildTimestamp,
  buildVersion: 2,
  production: true,
  baseApiPath: '/code-level'
};
